export default {
  freeGiftSet: {
    en: 'Add one more giftset and save $20.90',
  },
  freeProduct: {
    en: 'Add 1 more Scentbird Product and get both of them for just $25.',
  },
}
